if (!customElements.get('collection-list-expand')) {
  customElements.define(
    'collection-list-expand',
    class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.collection-list-more button');
        if (!this.button) return;

        this.onExpand = () => this.expand(true);
        this.onBlockSelect = (event) => {
          if (event.target.closest('[data-desktop-overflow]')) this.expand();
        };
        this.button.addEventListener('click', this.onExpand);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.button.setAttribute('aria-expanded', 'false');
        this.removeAttribute('data-expanded');
        this.setAttribute('data-collapsed', '');
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onExpand);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      expand(moveFocus = false) {
        const isMobile = window.matchMedia('(max-width: 989px)').matches && this.hasAttribute('data-mobile-more');
        const slider = this.querySelector('.collection-list');
        const items = Array.from(slider?.children || []);
        const sliderRight = slider?.getBoundingClientRect().right;
        const firstExtra = isMobile
          ? items.find((item) => item.getBoundingClientRect().left >= sliderRight) || items[0]
          : this.querySelector('[data-desktop-overflow]');

        this.setAttribute('data-expanded', '');
        this.removeAttribute('data-collapsed');
        this.button.setAttribute('aria-expanded', 'true');
        if (isMobile && slider) slider.scrollLeft = 0;

        if (moveFocus) {
          const firstLink = Array.from(firstExtra?.querySelectorAll('a[href]') || []).find(
            (link) => link.getClientRects().length > 0
          );
          firstLink?.focus({ preventScroll: true });
          firstExtra?.scrollIntoView({
            block: 'nearest',
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          });
        }
      }
    }
  );
}
